import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import checkmarkImg from "../images/checkmark.b8187469.svg"
import arrowForwardImg from "../images/arrow-forward.svg"
import $ from 'jquery';
import { secUser, guidance, database } from '../firebase'
export default class AssesmentApply5 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      personna: "",
      personnaData: []
    }
  }
  async componentDidMount() {
    let personnaList = []
    await database.ref("personna").orderByChild("sortOrder").once('value', function (snapshot) {
      snapshot.forEach(function (ChildSnapshot) {
        if (ChildSnapshot.val().status == 'Active') {
          personnaList.push({
            key: ChildSnapshot.key,
            image: ChildSnapshot.val().image,
            name: ChildSnapshot.val().name,
            internalId: ChildSnapshot.val().internalId
          });
        }
      });
    });
    this.setState({
      personnaData: personnaList
    })
    let data = JSON.parse(localStorage.getItem("guidanceArray"))
    console.log("data...",data)
    let personna = data.personna
    $('#'+personna).attr("checked",true)
  }
  updateValidateSubmission() {
    if ($('input[name="personna"]:checked').length == 0) {
      alert("Please select Where Do You See Yourself?")
      return false;
    }
    else {
      this.setState({
        personna: $('input[name=personna]:checked').val()
      })
      localStorage.setItem("progressInfo",40)
      const dataSet = {
        personna: $('input[name=personna]:checked').val(),
        progressInfo:40
      }
      database.ref(`Guidance/${this.props.match.params.key}`).update(dataSet).then(() => {
        localStorage.setItem("personna", this.state.personna ? this.state.personna : "")
        window.location.href = "/assesment/goal/id=" + this.props.match.params.key

      }).catch(() => {
        alert("Somthing went wrong")
      })
      //window.location.href = "/assesment/apply-1"
    }
  }
  render() {

    return (

      <div className="main-wrapper assesment-wrapper">
        <Header></Header>
        <div className="main-content assessment-radio">
          <div className="container-fluid pt-5">
            <div className='col-lg-12 m-auto'>
              <form className='form-main-wrapper form-main-wrapper-100 border-0' style={{ boxShadow: "unset" }}>
                <div className="form-group subhead">Where do you see yourself?</div>
                <div className="row justify-content-center">
                  {
                    this.state.personnaData.map((x, y) =>
                      <div className="col-md-4 col-lg-2 form-group text-center">
                        <img className="label-radio-design-img" src={x.image} />
                        <div className='row m-0'>
                          <label for="personna" className="label-radio-design">
                            <input name="personna" id={x.internalId} type="radio" value={x.internalId} />
                            <span>{x.name}</span>
                            <div className="label-radio-design-checkedBackground"></div>
                          </label>
                        </div>
                      </div>
                    )}
                  <div className="col-md-12 mt-4 text-center">
                    <a href="#" className="btn btn-gray w-50" onClick={() => this.updateValidateSubmission()}>
                      Next <img src={arrowForwardImg} className="arrow-filter"></img>
                    </a>
                  </div>
                </div>

              </form>
            </div>
          </div>
        </div>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ivano/assessment-personna.jsx